var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Cross } from '../icon';
import { Button } from '../button';
import { closeButtonStyle } from './styles';
import { useDialog } from './dialog-context';
function CloseButton(_a) {
    var restProps = __rest(_a, []);
    var hasDecorativeHeader = useDialog().hasDecorativeHeader;
    return (_jsx(Button, __assign({}, restProps, { variant: "plain", icon: _jsx(Cross, {}), "aria-label": "Close" }, (hasDecorativeHeader && { inverted: true }), { css: closeButtonStyle({ hasDecorativeHeader: hasDecorativeHeader }) })));
}
export default CloseButton;
